import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'step0',
    component: () => import(/* webpackChunkName: "step0View" */ '../views/step0View.vue')
  },
  {
    path: '/step1',
    name: 'step1',
    component: () => import(/* webpackChunkName: "step1View" */ '../views/step1View.vue')
  },
  {
    path: '/step2',
    name: 'step2',
    component: () => import(/* webpackChunkName: "step2View" */ '../views/step2View.vue')
  },
  {
    path: '/step3',
    name: 'step3',
    component: () => import(/* webpackChunkName: "step3View" */ '../views/step3View.vue')
  },
  {
    path: '/step4',
    name: 'step4',
    component: () => import(/* webpackChunkName: "step4View" */ '../views/step4View.vue')
  },
  {
    path: '/step5',
    name: 'step5',
    component: () => import(/* webpackChunkName: "step5View" */ '../views/step5View.vue')
  },
  {
    path: '/step6',
    name: 'step6',
    component: () => import(/* webpackChunkName: "step6View" */ '../views/step6View.vue')
  },
  {
    path: '/step7',
    name: 'step7',
    component: () => import(/* webpackChunkName: "step7View" */ '../views/step7View.vue')
  },
  {
    path: '/step8',
    name: 'step8',
    component: () => import(/* webpackChunkName: "step8View" */ '../views/step8View.vue')
  },
  {
    path: '/step9',
    name: 'step9',
    component: () => import(/* webpackChunkName: "step9View" */ '../views/step9View.vue')
  },
  {
    path: '/step10',
    name: 'step10',
    component: () => import(/* webpackChunkName: "step10View" */ '../views/step10View.vue')
  },
  {
    path: '/step11',
    name: 'step11',
    component: () => import(/* webpackChunkName: "step11View" */ '../views/step11View.vue')
  },
  {
    path: '/step12',
    name: 'step12',
    query: { payment: String },
    component: () => import(/* webpackChunkName: "step12View" */ '../views/step12View.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/loginView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/adminView.vue')
  },
  {
    path: '/instruction',
    name: 'instruction',
    component: () => import(/* webpackChunkName: "admin" */ '../views/instructionView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
